import React from 'react';
import PropTypes from 'prop-types';

import { FormattedNumber } from 'react-intl';
// components
import { Card } from 'material-ui/Card';
import { Link } from 'react-router';

const style = {
    iconWatermark: {
        marginLeft:0,
        height: '50px',
        width: '50px',
        position: 'absolute',
        color: 'rgba(117, 117, 117 ,0.3)'
    },
};

const StatWidget = ({url, title, count, statString, icon: IconElement}) => {

    return (
        <Card className="cent-card cent-card-micro">
            <div className='cent-stat'>
                <div className='cent-stat-count'>
                    <Link to={url} ><FormattedNumber value={count}/></Link>
                    <Link to={url} ><i>{statString}</i></Link>
                </div>
                <div className='cent-stat-title'>
                    <Link to={url}  >
                        {title}
                    </Link>
                </div>
                <div className='cent-stat-icon'>
                    <Link to={url}  >
                        <IconElement style={style.iconWatermark}  />
                    </Link>
                </div>
            </div>
        </Card>
    );
};

StatWidget.propTypes = {
    title:      PropTypes.string.isRequired,
    url:        PropTypes.string,
    count:      PropTypes.number.isRequired,
    statString: PropTypes.string,
    icon:       PropTypes.func.isRequired,
    actions:    PropTypes.arrayOf(PropTypes.object)
};

StatWidget.defaultProps = {
    actions:    [],
    statString: ''
};

export default StatWidget;
